export enum SoundTypes {
  General = 'general',
  Ping = 'ping',
  Incoming = 'incoming',
}

import generalSound from '@shared/assets/sounds/general.mp3'
import incomingSound from '@shared/assets/sounds/incoming.mp3'
import pingSound from '@shared/assets/sounds/ping.mp3'

const audios: Record<SoundTypes, HTMLAudioElement> = {
  [SoundTypes.General]: new Audio(generalSound),
  [SoundTypes.Ping]: new Audio(pingSound),
  [SoundTypes.Incoming]: new Audio(incomingSound),
}

export const playSound = (type: SoundTypes) => audios[type].play()
